import { create } from 'zustand'

interface TranslationUploadState {
  isLoading: boolean
  id?: string
  error?: unknown
  setIsLoading: (isLoading: boolean) => void
  setId: (id: string) => void
  setError: (error: unknown) => void
  resetTranslationUpload: () => void
}

export const useTranslationUploadStore = create<TranslationUploadState>(set => ({
  isLoading: false,
  id: '',
  error: undefined,
  setIsLoading: isLoading => {
    set({ isLoading })
  },
  setId: id => {
    set({ id })
  },
  setError: error => {
    set({ error })
  },
  resetTranslationUpload: () => {
    set({ isLoading: false, id: '', error: undefined })
  },
}))
